import { render, staticRenderFns } from "./GravarRepresentanteDialog.vue?vue&type=template&id=65e367af&"
import script from "./GravarRepresentanteDialog.vue?vue&type=script&lang=js&"
export * from "./GravarRepresentanteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports